var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttensionSpanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#2573EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.59 28.109L32.41 27L24.975 30.78C24.405 31.07 23.732 31.07 23.162 30.78L15.727 27L13.547 28.109C13.3824 28.1926 13.2442 28.3202 13.1476 28.4775C13.0511 28.6349 13 28.8159 13 29.0005C13 29.1851 13.0511 29.3661 13.1476 29.5235C13.2442 29.6808 13.3824 29.8084 13.547 29.892L23.162 34.781C23.732 35.071 24.405 35.071 24.975 34.781L34.59 29.892C34.7546 29.8084 34.8928 29.6808 34.9893 29.5235C35.0859 29.3661 35.137 29.1851 35.137 29.0005C35.137 28.8159 35.0859 28.6349 34.9893 28.4775C34.8928 28.3202 34.7546 28.1926 34.59 28.109Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.163 15.2175L13.547 20.1065C13.3824 20.1901 13.2442 20.3177 13.1476 20.475C13.0511 20.6324 13 20.8134 13 20.998C13 21.1826 13.0511 21.3636 13.1476 21.5209C13.2442 21.6783 13.3824 21.8058 13.547 21.8895L23.162 26.7785C23.732 27.0685 24.405 27.0685 24.975 26.7785L34.59 21.8895C34.7546 21.8058 34.8928 21.6783 34.9893 21.5209C35.0859 21.3636 35.137 21.1826 35.137 20.998C35.137 20.8134 35.0859 20.6324 34.9893 20.475C34.8928 20.3177 34.7546 20.1901 34.59 20.1065L24.975 15.2175C24.6944 15.0745 24.3839 15 24.069 15C23.7541 15 23.4436 15.0745 23.163 15.2175Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttensionSpanIcon);
export default __webpack_public_path__ + "static/media/AttensionSpanIcon.a845570348f03d4d3963a0814338664d.svg";
export { ForwardRef as ReactComponent };